import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import React, { useCallback, useEffect } from "react";
var _createContextStore = createContextStore({
    height: 0,
    shouldKeepTopNavVisible: false,
    bannerHeight: 0,
    isBannerInView: false
}), useStore = _createContextStore.useStore, Provider = _createContextStore.Provider;
var Synchronizer = function() {
    var _useStore = _sliced_to_array(useStore([
        "bannerHeight"
    ]), 2), bannerHeight = _useStore[0].bannerHeight, setStore = _useStore[1];
    /**
     * Called on scroll events to determine if the banner is in view.
     */ var handleScrollEvent = useCallback(function() {
        var scrollY = getWindowOrThrow().scrollY;
        if (bannerHeight - scrollY <= 0) {
            setStore(function(param) {
                var isBannerInView = param.isBannerInView;
                return isBannerInView ? {
                    isBannerInView: false
                } : {};
            });
        } else {
            setStore(function(param) {
                var isBannerInView = param.isBannerInView;
                return isBannerInView ? {} : {
                    isBannerInView: true
                };
            });
        }
    }, [
        bannerHeight,
        setStore
    ]);
    useEffect(function() {
        getWindowOrThrow().addEventListener("scroll", handleScrollEvent);
        return function() {
            getWindowOrThrow().removeEventListener("scroll", handleScrollEvent);
        };
    }, [
        handleScrollEvent
    ]);
    return null;
};
export var useTopOfPageContextStore = useStore;
export var TopOfPageContextStoreProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(Provider, {
        children: [
            children,
            /*#__PURE__*/ _jsx(Synchronizer, {})
        ]
    });
};
